import useResource from "../../../hooks/UseResource";
import * as PhysiotherapistService from "../../../services/PhysiotherapistService";

export default function usePhysiotherapist(id) {
    return useResource(id, PhysiotherapistService.findPhysiotherapistById);
}
